export default __webpack_public_path__ + "static/legal-document-management-solution-0de1cbdfba21c837046243aeb949dcdb.png";